import React from "react";
// import {CircularProgressbar} from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';

// Stylesheet file.
import '../../../assets/sass/global/cards/player-ability-card-item.scss';
import Tools from "../../../Tools";
import CircularProgressBar from "../progress_bars/CircularProgressBar";

const PlayerAbilityCardItem = props => {
    const {title, description, value, attachments, onAttachmentClick} = props;
    const attachmentsText = attachments.length ? Tools.maybePluralize(attachments.length, 'Attachment') : '';

    return (
        <div className="player-ability-card-item">
            <div className="text-container">
                <div className="d-flex justify-content-between">
                    <div className="title"> {title}</div>
                    <div className="attachments" onClick={onAttachmentClick}> {attachmentsText} </div>
                </div>
                <div className="description"> {description}</div>
            </div>
            <div className="circular-progressbar-container">
                <CircularProgressBar percentage={value} text={value}/>
            </div>
        </div>
    );
};

export default PlayerAbilityCardItem;
